import {Route} from "@angular/router";
import {guardNormativesWatch} from "@/app/routes/guards/normatives-guard";

const NAME = 'Нормативы'

export const normatives: Route[] = [
    {
        path: 'normatives',
        loadComponent: () => import('@components/guides/normatives/normatives.component').then(c => c.NormativesComponent),
        canActivate: [guardNormativesWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'normatives/:id',
        loadComponent: () => import('@components/guides/normatives/normative-details/normative-details.component').then(c => c.NormativeDetailsComponent),
        canActivate: [guardNormativesWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/normatives/'},
            ],
        },

    },
]
